// extracted by mini-css-extract-plugin
export var numpadContainer = "_jg-1";
export var phoneButton = "_jg-0";